import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apikey, ApikeyData } from '../../shared/interfaces/apikey.interfaces';

const basePath = '/apikey';

@Injectable({
  providedIn: 'root'
})
export class ApiKeyService {
  constructor(private http: HttpClient) { }

  // Gets a list of not revoked API keys for the current dealer
  getApikeys(): Observable<ApikeyData[]> {
    return this.http.get<ApikeyData[]>(basePath);
  }

  // Creates a new API key for the current dealer
  createApikey(name: string): Observable<Apikey> {
    return this.http.post<Apikey>(basePath, { name });
  }

  // Updates an existing API key revoked status to true
  revokeApiKey(apikeyId: any) {
    return this.http.put(`${basePath}/${apikeyId}/revoke`, {});
  }
}